import styled from "styled-components";

const DetailedPageDivImg = styled.div`
  height: 400px;
  width: 40%;
  flex-shrink: 0;
  @media screen and (max-width: 899px) {
    width: 100%;
  }
`;

export default DetailedPageDivImg;
